<template>
    <div :class="{ [theme.wrapper]: true, [theme.active]: isActive }">
        <div class="input-group input-group-sm">
            <input
                ref="search"
                v-model="searchText"
                type="text"
                placeholder="Search"
                class="form-control"
                dusk="snapgrid-search"
                @keypress.enter="search"
            />

            <span class="input-group-append">
                <button
                    class="btn btn-default"
                    type="button"
                    dusk="snapgrid-search-submit"
                    @click="search"
                    v-text="'Go!'"
                />
            </span>
        </div>

        <span
            v-show="isActive"
            class="fa-solid fa-times"
            :class="theme.clear"
            @click="clear"
        />
    </div>
</template>

<script>
import Common from './mixins/Common.vue';

export default {
    mixins: [Common],
    props: {
        data: Object,
        filter: Object,
    },
    data() {
        return {
            searchText: '',
        };
    },
    computed: {
        isActive() {
            return !!this.filter.current_value;
        },
    },
    mounted() {
        this.searchText = this.filter.default_value
            ? String(this.filter.default_value)
            : '';
    },
    methods: {
        search() {
            this.filter.current_value = this.searchText;
            this.bus.$emit('filter-changed');
        },
        clear() {
            this.filter.current_value = '';
            this.searchText = '';
            this.bus.$emit('filter-changed');
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/search_filter.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/search_filter.scss"
></style>
